<template>
  <div class="home">
    <Menu/>
    <PwdChange :emailx="$usrStore.email" :mNbrx="$usrStore.mNbr" :aKey="Math.random()" :adm="$hasRole(['adm','sys'])"/>
  </div>
</template>

<script>
// @ is an alias to /src
import Menu from '@/components/Menu.vue'
import PwdChange from '@/components/PwdChange.vue'

export default {
  name: 'ModPwd',
  components: {
    Menu,
    PwdChange
  }
}
</script>
